export enum DATA_QA {
  ROOT = 'phone-details',
  PHONE_NUMBER = 'phone-details-phone-number',
  DNC = 'phone-details-dnc',
  DNC_SCOPE = 'phone-details-dnc-scope',
  DNC_OPT_OUT_DATE = 'phone-details-dnc-opt-out-date',
  DNC_EXPIRATION = 'phone-details-dnc-expiration',
  DNT = 'phone-details-dnt',
  DNT_SCOPE = 'phone-details-dnt-scope',
  DNT_OPT_OUT_DATE = 'phone-details-dnt-opt-out-date',
  DNT_EXPIRATION = 'phone-details-dnt-expiration',
  LAST_UPDATED = 'phone-details-last-updated',
}
